import React, { useMemo } from 'react'
import R from 'ramda'
import moment from 'moment'
import { CartesianGrid, Legend, Line, LineChart, XAxis, YAxis } from 'recharts'

const OperationalTruwupLineGraphPrice = ({
  width = 730,
  height = 250,
  tdata = {},
  startDate = moment('2024-01-01'),
  endDate = moment('2024-01-30'),
}) => {
  const { daLmp = [], rtLmp = [], genCost = [] } = tdata

  const parseIntFunc = val => parseInt(val)

  const daGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.dateTime, parseIntFunc(d.value1)])
      )(daLmp),
    [daLmp]
  )
  const rtGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.dateTime, parseIntFunc(d.value1)])
      )(rtLmp),
    [rtLmp]
  )
  const genCostGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.dateTime, parseIntFunc(d.value1)])
      )(genCost),
    [genCost]
  )

  const data = useMemo(
    _ => {
      let effStartMoment = moment(startDate).clone()
      const effEndDate = moment(endDate).clone()
      const dateFormat = 'YYYY-MM-DDTHH:mm:ss.SSS'
      const odata = []
      while (effStartMoment.isSameOrBefore(effEndDate)) {
        const f = effStartMoment.format(dateFormat)
        const dt = {
          date: effStartMoment.toDate().getTime(),
          dt: effStartMoment.format(dateFormat),
          daLmp: daGroup[f],
          rtLmp: rtGroup[f],
          genCost: genCostGroup[f],
        }
        odata.push(dt)
        // effStartMoment = effStartMoment.clone().add(1, 'hour')
        effStartMoment = effStartMoment.clone().add(1, 'day')
      }
      return odata
    },
    [daGroup, endDate, genCostGroup, rtGroup, startDate]
  )

  return (
    <div>
      <div
        style={{ paddingLeft: '10%', fontSize: '20px', textAlign: 'center' }}
      >
        Prices ($/MWh)
      </div>
      <LineChart
        height={height}
        width={width}
        data={data}
        margin={{ top: 5, right: 30, left: 40, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="1 1" />
        <XAxis
          dataKey="date"
          scale="auto"
          tickFormatter={d => moment(d).format('MM/DD')}
        />
        <YAxis
          yAxisId="yaxis"
          type="number"
          scale="auto"
          domain={[0, 'auto']}
          allowDataOverflow
          tickFormatter={e => '$' + e}
        />
        {/* <Tooltip /> */}
        <Legend align="center" verticalAlign="bottom" />
        <Line
          type="line"
          dataKey="daLmp"
          stroke="orange"
          yAxisId="yaxis"
          name="DA LMP"
          dot={false}
        />
        <Line
          type="line"
          dataKey="rtLmp"
          stroke="green"
          yAxisId="yaxis"
          name="RT LMP"
          dot={false}
        />
        <Line
          type="line"
          dataKey="genCost"
          stroke="blue"
          yAxisId="yaxis"
          name="Gen Cost"
          dot={false}
        />
      </LineChart>
    </div>
  )
}

export default OperationalTruwupLineGraphPrice
